// src/pages/GetInvolved.js
import React from 'react';

const GetInvolved = () => {
    return (
        <div>
            <h1>Get Involved</h1>
            <p>Find out how you can help our cause.</p>
        </div>
    );
};

export default GetInvolved;
